const prefix = 'storage.';

export const storage = {
  getAll() {
    const data = {};

    for (const key in localStorage) {
      if (key.indexOf(prefix) === 0) {
        data[key.replace(prefix, '')] = storage.getFromLocalStorage(key);
      }
    }

    return data;
  },

  getFromLocalStorage(key) {
    let value = localStorage.getItem(key);
    try {
      value = JSON.parse(value);
    } catch (e) {
      // if (console) console.log(key + " doesnt seems to be JSON");
    }

    return value;
  },

  // Get item from localStorage
  get(key, defaultValue) {
    return storage.getFromLocalStorage(prefix + key) || defaultValue;
  },

  // Set item in localStorage
  set(key, value) {
    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }
    localStorage.setItem(prefix + key, value);
  },

  remove(key) {
    localStorage.removeItem(prefix + key);
  },
};
